const sanityClient = require('@sanity/client')

const client = sanityClient({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
})

const getSanityDocument = (slug) => {
  return new Promise((resolve, reject) => {
    var query = `*[_type in ["issue", "article", "page", "lag"] && slug.current == '${slug}'] | {
      ...,
      "document": document -> { title, description,"file": file{"asset": asset->url}},
      program{ content[]{..., "file": file{"asset": asset->url}}},
      "related_issues": related_issues[]->{title, slug},
      "thumbnail": thumbnail{"asset": asset->{url}},
      "headerImage": image{..., "asset": asset->{url}},
      "chapterHeaderImage": headerImage{image{..., "asset": asset->{url}}},
      "groups": groups[]{title, "members": members[]{role, "person": person->{name, phone, email, facebook, twitter, instagram, "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}}}},
      "county": county->{..., title, slug},
      contact{..., "leader": leader->{..., "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}}},
      "blocks": blocks{
        "content": content[]{
          ...,
          "file": file{"asset": asset->url},
          "document": document->{
            title,
            description,
            "file": file{"asset": asset->url}
          },
          "image": image{..., "asset": asset->{url, metadata}},
          "person": person->{
            ...,
            "profile_image": profile_image {
              crop,
              hotspot,
              "asset": asset->{url, metadata}
            }
          },
          "members": members[] {
            role,
            "person": person->{
              ...,
              "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}
            }
          }
        }
      }
    }`
    client.fetch(query).then(result => {
      resolve(result[0])
    })
  })
}

export default getSanityDocument



// WEBPACK FOOTER //
// ./src/getSanityDocument.js